import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { applogo, edit, plus, trash } from "../../assets";
import PaginationComponent from "../Shared/PaginationComponent";
import CustomFilters from "./CustomFIlters";
import * as authActions from "../../actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { RiSearchLine } from "react-icons/ri";
import NoData from "../Shared/NoData";
import DeleteModal from "../Shared/DeleteModal";
import { FiEye } from "react-icons/fi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import {
  truncateString,
  formatDateTimeString,
  formatDateToTextDate,
  formatPrice,
  formatTimesheetDateToTextDate,
  getMediaUrl,
  getDownloadUrlFromResponse,
  formatDateTimeTogetherString,
  toTitleCase,
} from "../../utils";
import { LuUserCircle2 } from "react-icons/lu";
import CustomAddModal from "./CustomAddModal";
import CustomAddBox from "./CustomAddBox";
import { notify } from "../../actions/notify";
import InvoiceActions from "./InvoiceActions";
import MilestoneActions from "./MilestoneActions";
import ProjectActions from "./ProjectActions";
import LeaveActions from "./LeaveActions";
import Select from "react-select";

const recurringTimeOptions = [
  { value: 7, label: "Weekly" },
  { value: 15, label: "Bi-Weekly" },
  { value: 30, label: "1 month" },
  { value: 60, label: "2 months" },
  { value: 90, label: "3 months" },
];

const getValue = (heading, item) => {
  if (heading?.key?.includes(".")) {
    const keys = heading.key.split(".");
    let value = item;
    try {
      for (const key of keys) {
        if (value === null || value === undefined) {
          return "N/A";
        }
        value = value[key];
      }
      return value;
    } catch (error) {
      return "N/A";
    }
  } else {
    return item[heading.key] ?? "N/A";
  }
};

const  CustomTable = ({
  filters,
  rowHeadings,
  button,
  button2,
  createUrl,
  openCreateOnMount = false,
  onCreateSuccess,
  viewUrl,
  viewType,
  type,
  rowActions,
  backendUrl,
  exportUrl,
  exportMethod = "get",
  download = false,
  exportFlagParam,
  exportUsesFilePath = false,
  title,
  subtitle,
  searchbar = false,
  deleteUrl,
  fetchAgain = false,
  setFetchAgain,
  deleteTitle,
  clientId = false,
  showSearchReset = false,
  contacts,
  showSubtitle = false,
  showExport = false,
  createLayout,
}) => {
  const navigate = useNavigate();
  const scrollToTopRef = useRef(null);
  const { user, token } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [rowData, setRowData] = useState([]);
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(1);
  const [exporting, setExporting] = useState(false);
  const [filterUrl, setFilterUrl] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [submitting, setSubmitting] = useState(false)
  const [showAdd, setShowAdd] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    if (openCreateOnMount) {
      if (createUrl === "modal") {
        setShowAddModal(true);
      } else if (createUrl === "invoice") {
        navigate("/invoices/add");
      } else {
        setShowAdd(true);
      }
      setItemId(null);
      window?.scrollTo(0, 0);
    }
    // Intentionally only reacts to prop changes
  }, [openCreateOnMount, createUrl, navigate]);
  const [showRegister, setShowRegister] = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [showNonRecoverable, setShowNonRecoverable] = useState(false);
  const [nonRecoverableReason, setNonRecoverableReason] = useState("");
  const [showDelayCharges, setShowDelayCharges] = useState(false)
  const [markRedFlag, setMarkRedFlag] = useState(false);

  const [itemId, setItemId] = useState(false);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState("100%");

  // filter variables
  const [vendor, setVendor] = useState(null);
  const [ordering, setOrdering] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [client, setClient] = useState("");
  const [status, setStatus] = useState("");
  const [projectType, setProjectType] = useState("");
  const [invoiceType, setInvoiceType] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [timesheetFilters, setTimesheetFilters] = useState({
    start_date: "",
    end_date: "",
    project: "",
    employee: "",
  });

  const filterVariables = {
    vendor,
    setVendor,
    ordering,
    setOrdering,
    paymentStatus,
    setPaymentStatus,
    client,
    setClient,
    status,
    setStatus,
    projectType,
    setProjectType,
    invoiceType,
    setInvoiceType,
    year,
    setYear,
    month,
    setMonth,
    timesheetFilters,
    setTimesheetFilters,
  };

  useEffect(() => {
    if (fetchAgain) {
      fetchRecords();
      setFetchAgain(false);
    }
  }, [fetchAgain]);

  useEffect(() => {
    fetchRecords();
    updateWidth();
    window.addEventListener("resize", updateWidth);
    setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (showAdd) {
      window.scrollTo(0, 0);
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      window.scrollTo(0, 0);
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [showAdd]);

  const handleMarkNonRecoverable = async (invoiceId, reason, markRedFlag) => {
    try {
      setSubmitting(true)
      const resp = await authActions.customAction(
        `invoice/mark-non-recoverable/`,
        "post",
        {
          invoice_id: invoiceId,
          reason: reason,
          red_flag: markRedFlag,
        },
        token,
        "Invoices"
      );
      if (resp) {

        fetchRecords(filterUrl || backendUrl)
      }
    } catch {
      setSubmitting(false)
    } finally {
      setNonRecoverableReason('')
      setMarkRedFlag(false)
      setSubmitting(false)
    }
  };

  const handleFilterChange = (key, value) => {
    const setterName = `set${key?.charAt(0)?.toUpperCase() + key?.slice(1)}`;
    if (typeof filterVariables[setterName] === "function") {
      filterVariables[setterName](value);
    }

    let url = filterUrl ? filterUrl : backendUrl;
    if (!url.includes("?")) {
      url += "?";
    } else if (!url.endsWith("&") && !url.endsWith("?")) {
      url += "&";
    }

    const params = new URLSearchParams(url.split("?")[1]);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }

    params.set("page", "1");

    const updatedUrl = `${backendUrl.split("?")[0]}?${params.toString()}`;

    setFilterUrl(updatedUrl);
    setPage(1);

    fetchRecords(updatedUrl);
  };

  const updateWidth = () => {
    try {
      if (containerRef?.current) {
        setContainerWidth(containerRef.current.scrollWidth);
      }
    } catch {
      console.log("error in width");
    }
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  const handleScrollToTop = () => {
    if (scrollToTopRef.current) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const fetchRecords = async (fetchUrl = backendUrl) => {
    setLoading(true);
    const response = await authActions.customAction(
      fetchUrl,
      "fetch",
      [],
      token,
      title
    );
    console.log(response)
    if (response) {
      setTotalItems(response.count ? response.count : null);
      setRowData(response.results ? response.results : response);
    }
    setLoading(false);
  };

  const handleMarkMilestoneComplete = async (item, status = "COMPLETED") => {
    const resp = await authActions.customAction(
      `project/milestone/${item?.id}/`,
      "patch",
      { title: item?.title, project: item?.project, status: status },
      token
    );
    if (resp) {
      fetchRecords();
    }
  };

  const handleMarkProjectComplete = async (item) => {
    if (item?.status !== "COMPLETED") {
      const resp = await authActions.customAction(
        `${backendUrl}/${item?.id}/`,
        "patch",
        { title: item?.title, status: "COMPLETED", ongoing: false },
        token
      );
      if (resp) {
        fetchRecords();
      }
    } else {
      notify("Project is already completed", "warning");
    }
  };

  const handleFileDownload = async (item) => {
    const fileUrl = getMediaUrl(item?.file);
    if (!fileUrl) {
      console.error("No file URL available");
      return;
    }

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleSendInvoice = async (id, contacts) => {
    const formData = new FormData();
    formData.append("selected_contacts", JSON.stringify(contacts));
    formData.append("invoice", id);
    const response = await authActions.customAction(
      "invoice/sendinvoice/",
      "post",
      formData,
      token,
      "Send Invoice"
    );
    if (response) {
      fetchRecords();
    }
  };

  const handleDownloadInvoice = async (id) => {
    setDownloading(true);
    const formData = new FormData();
    formData.append("invoice", id);
    const response = await authActions.customAction(
      "invoice/download_invoice/",
      "post",
      formData,
      token,
      "Download Invoice"
    );
    if (response) {
      if (response?.pdf_url) {
        const pdfName = response?.pdf_name;
        const pdfUrl = getMediaUrl(response?.pdf_url);
        const pdfResponse = await fetch(pdfUrl);
        const pdfBlob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${pdfName}.pdf`);
        link.click();
        URL.revokeObjectURL(blobUrl);
      }
    }
    setDownloading(false);
  };

  const handleSendReminder = async (id) => {
    const formData = new FormData();
    formData.append("invoice", id);
    const response = await authActions.customAction(
      "invoice/sendreminder/",
      "post",
      formData,
      token,
      "Send Reminder"
    );
    if (response) {
      fetchRecords();
    }
  };

  const handleDelete = async (id) => {
    const response = await authActions.customAction(
      deleteUrl ? deleteUrl + `/${id}/` : backendUrl + `/${id}/`,
      "delete",
      [],
      token,
      deleteTitle ? deleteTitle : title
    );
    if (response) {
      if (title === 'Invoice Payment') {
        typeof setFetchAgain === 'function' && setFetchAgain(true)
      }
      setRowData(rowData.filter((item) => item.id !== id));
    }
  };

  const handleStatusChange = async (e, id, itemStatus = "ACTIVE") => {
    e.preventDefault();
    if (
      (title === "Employee" && user?.is_admin) ||
      (!user?.is_admin && title !== "Employee")
    ) {
      const formData = new FormData();
      if (itemStatus === "ACTIVE") {
        formData.append("status", title === "Employee" ? "LEFT" : "INACTIVE");
      } else if (itemStatus === "INACTIVE" || itemStatus === "LEFT") {
        formData.append("status", "ACTIVE");
      }
      const response = await authActions.customAction(
        backendUrl + `/${id}/`,
        "patch",
        formData,
        token,
        title,
        false,
        false
      );

      if (response) {
        notify("Status updated successfully", "success");
        fetchRecords();
      }
    }
  };

  const handleStopResumeInvoice = async (id, status) => {
    const payload = {
      is_stopped: !status,
    };
    const response = await authActions.customAction(
      "invoice/stop-resume-invoice" + `/${id}/`,
      "patch",
      payload,
      token,
      title,
      false,
      false
    );
    if (response) {
      notify("Invoice updated successfully", "success");
      fetchRecords();
    }
  };

  const handlePagination = async (e) => {
    const updateOrAddPageParam = (url, page) => {
      if (url.includes("page=")) {
        return url.replace(/page=\d+/, `page=${page}`);
      } else if (url.includes("?")) {
        return url + `&page=${page}`;
      } else {
        return url + `?page=${page}`;
      }
    };
    let newUrl;
    newUrl = updateOrAddPageParam(filterUrl ? filterUrl : backendUrl, e);
    setFilterUrl(newUrl);
    fetchRecords(newUrl);
    handleScrollToTop();
  };

  const handleUrlClick = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }
    window.open(url, "_blank");
  };

  const handleApproveRejectLeave = async (actionType, id, reason = null) => {
    let data = { status: actionType === "accept" ? "APPROVED" : "REJECTED" };
    if (reason) {
      data.rejection_reason = reason;
    }
    const resp = await authActions.customAction(
      `leave/update-status/${id}/`,
      "post",
      data,
      token
    );
    if (resp) {
      fetchRecords();
      fetchLeaveCount();
    }
  };
  const handleReset = () => {
    setVendor(null);
    setSearchKey("");
    setOrdering("");
    setPaymentStatus("");
    setClient("");
    setStatus("");
    setProjectType("");
    setInvoiceType("");
    setTimesheetFilters({
      start_date: "",
      end_date: "",
      project: "",
      employee: "",
    });
    setFilterUrl("");
    setYear('');
    setMonth('');
    setPage(1);
    fetchRecords(backendUrl);
  };

  const handleExport = async () => {
    setExporting(true);

    if (title === "GST Report") {
      if (!year?.value || !month?.value) {
        notify("Please select the year and month before downloading the report.", "error");
        setExporting(false);
        return;
      }
    }

    const exportFlag = exportFlagParam || (download ? "download" : "export");
    const activeUrl = (filterUrl && filterUrl.length > 0 ? filterUrl : backendUrl) || "";
    const activeQuery = activeUrl.split("?")[1] || "";

    const exportEndpoint = exportUrl || backendUrl;
    let hasQuery = exportEndpoint?.includes("?");
    let exportRequestUrl = exportEndpoint || "";

    if (activeQuery) {
      exportRequestUrl += (hasQuery ? "&" : "?") + activeQuery;
      hasQuery = true;
    }

    // ensure export/download flag is present for GET exports (and kept for POST payload too)
    if (exportRequestUrl.includes("?")) {
      exportRequestUrl += `&${exportFlag}=true`;
    } else {
      exportRequestUrl += `?${exportFlag}=true`;
    }

    let response;
    if (String(exportMethod).toLowerCase() === "post") {
      const queryString = exportRequestUrl.split("?")[1] || "";
      const params = new URLSearchParams(queryString);
      params.delete("page");
      params.delete(exportFlag);

      const payload = {};
      for (const [key, value] of params.entries()) {
        if (payload[key] === undefined) {
          payload[key] = value;
        } else if (Array.isArray(payload[key])) {
          payload[key].push(value);
        } else {
          payload[key] = [payload[key], value];
        }
      }

      if (exportUsesFilePath) {
        const generated = await authActions.customAction(
          exportRequestUrl,
          "post",
          payload,
          token,
          title,
          false,
          false
        );

        const fileUrl = getDownloadUrlFromResponse(generated);
        if (fileUrl) {
          const rawPath = generated?.file_path || generated?.file_url || "";
          const nameFromPath = String(rawPath).split("/").pop();

          try {
            const fileResponse = await fetch(fileUrl);
            const blob = await fileResponse.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute(
              "download",
              nameFromPath || `${title.toLowerCase()}_export.xlsx`
            );

            document.body.appendChild(link);
            link.click();
            link.remove();
          } catch (e) {
            notify("Something went wrong please export later.", "error");
            console.log(e);
          } finally {
            setExporting(false);
          }
          return;
        }

        notify("Unable to generate report for download.", "error");
        setExporting(false);
        return;
      }

      response = await authActions.customAction(
        exportRequestUrl,
        "export-post",
        payload,
        token,
        title
      );
    } else {
      response = await authActions.customAction(
        exportRequestUrl,
        "export",
        [],
        token,
        title
      );
    }

    if (response) {
      try {
        const blob = response.data;
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", `${title.toLowerCase()}_export.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      catch (e) {
        notify("Something went wrong please export later.", "error");
        console.log(e)
      } finally {
        setExporting(false);
      }
    }
    setExporting(false);
  }

  const fetchLeaveCount = async () => {
    const resp = await authActions.customAction(
      `leave/pending-leave-count`,
      "fetch",
      null,
      token
    );
    if (resp) {
      dispatch(authActions.updateLeaveCount(resp.pending_leave_count));
    }
  };

  return (
    <div
      ref={scrollToTopRef}
      className={`w-100 ${title === "Invoice Payment" ? "mb-2" : "mb-5 pb-4"}`}
    >
      <div>{type === "booking" && " Filter by:"}</div>
      <div className="d-flex flex-wrap justify-content-between ">
        {title && (
          <div className="ms-2 d-flex align-items-center fs-25 fw-700">
            {title === "Timesheets" ? "Timesheet" : title === 'Finance - Expenses' ? 'Finance - Expense' : title}s
          </div>
        )}
        {button && user?.is_admin && (
          <div className="d-flex align-items-center">
            <Button
              onClick={() => {
                if (createUrl === "modal") {
                  setShowAddModal(true);
                  window?.scrollTo(0, 0);
                  setItemId(null);
                } else if (createUrl === "invoice") {
                  navigate("/invoices/add");
                } else {
                  setShowAdd(true);
                  setItemId(null);
                }
              }}
              className="d-flex align-items-center border-transparent py-2"
            >
              <img
                src={plus}
                alt=""
                className="me-1"
                style={{ height: "18px" }}
              />{" "}
              <span className="d-flex">{button}</span>
            </Button>
          </div>
        )}
        {button2 && !user?.is_admin && (
          <div className="d-flex align-items-center">
            <Button
              onClick={() => {
                if (title === "Leave") {
                  setShowAdd(true);
                  setItemId(null);
                } else if (createUrl === "modal") {
                  setShowAddModal(true);
                  window?.scrollTo(0, 0);
                  setItemId(null);
                }
              }}
              className="d-flex align-items-center border-transparent py-2"
            >
              <img
                src={plus}
                alt=""
                className="me-1"
                style={{ height: "18px" }}
              />{" "}
              <span className="d-flex">{button2}</span>
            </Button>
          </div>
        )}
      </div>
      <div className="br-10 bg-white my-3 mb-5 ">
        <div className="px-4 d-flex flex-wrap justify-content-between">
          {showSubtitle && (subtitle || title) && title !== "Invoice Payment" && (
            <div className="mt-2 col-6 d-flex align-items-center fs-18 fw-600">
              {subtitle ? subtitle : `${title} List`}
            </div>
          )}
          {!showSubtitle && <div>

          </div>}

          <div
            className={`d-flex justify-content-end flex-column flex-md-row align-items-center mt-3 mb-2 col-6`}
          >
            {title === "Finance - Expenses" ||
              backendUrl?.includes(`expense/expense?project`) ? (
              <CustomFilters
                type={"expense"}
                fetchRecords={fetchRecords}
                setFilterUrl={setFilterUrl}
                page={page}
                title={title}
                backendUrl={backendUrl}
                setPage={setPage}
                filterVariables={filterVariables}
              />
            ) : title === "Projects Report" ? (
              <CustomFilters
                type={"project_report"}
                fetchRecords={fetchRecords}
                setFilterUrl={setFilterUrl}
                page={page}
                title={title}
                backendUrl={backendUrl}
                setPage={setPage}
                filterVariables={filterVariables}
              />
            ) : title === "GST Report" ? (
              <CustomFilters
                type={"gst_report"}
                fetchRecords={fetchRecords}
                setFilterUrl={setFilterUrl}
                page={page}
                title={title}
                backendUrl={backendUrl}
                setPage={setPage}
                filterVariables={filterVariables}
              />
            ) : title === "Timesheets" ? (
              <CustomFilters
                type={title}
                fetchRecords={fetchRecords}
                filterUrl={filterUrl}
                setFilterUrl={setFilterUrl}
                page={page}
                title={title}
                backendUrl={backendUrl}
                setPage={setPage}
                filterVariables={filterVariables}
              />
            ) : (
              <>
                {filters?.map((item, index) => (
                  item?.type === 'select' ? <Select
                    key={index}
                    options={item.options || []}
                    className='br-10 border-primary me-2'
                    placeholder={item.title}
                    value={
                      filterVariables[item.url]
                        ? item.options?.find(opt => opt.value === filterVariables[item.url])
                        : null
                    }
                    onChange={(option) => option && handleFilterChange(item.url, option.value)}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: '1px solid #e0e0e0 !important',
                        borderRadius: '12px !important',
                        padding: '0px 6px',
                        minWidth: '120px',
                        width: '100%',
                        fontSize: '14px'
                      }),
                    }}
                  /> :
                    <CustomFilters
                      key={index}
                      title={item.title}
                      show={filterUrl?.includes("ordering")}
                      fetchRecords={fetchRecords}
                      filterUrl={filterUrl ? filterUrl : backendUrl}
                      setFilterUrl={setFilterUrl}
                      type={title}
                      setPage={setPage}
                      filterVariables={filterVariables}
                      onClick={() => {
                        if (
                          filterUrl?.includes("search") &&
                          !filterUrl?.includes("ordering")
                        ) {
                          let url = filterUrl + "&" + item.url;
                          fetchRecords(url);
                          setFilterUrl(url);
                        } else if (
                          !filterUrl?.includes("search") &&
                          filterUrl?.includes("ordering")
                        ) {
                          fetchRecords(backendUrl);
                          setFilterUrl(backendUrl);
                        } else if (
                          filterUrl?.includes("search") &&
                          filterUrl?.includes("ordering")
                        ) {
                          let url = backendUrl + `?search=${searchKey}`;
                          fetchRecords(url);
                          setFilterUrl(url);
                        } else if (backendUrl.slice(-1) === "&") {
                          setFilterUrl(backendUrl + item.url);
                          fetchRecords(backendUrl + item.url);
                        } else {
                          setFilterUrl(backendUrl + "?" + item.url);
                          fetchRecords(backendUrl + "?" + item.url);
                        }
                      }}
                    />
                ))}
              </>
            )}
            {searchbar && (
              <>
                <div className="d-flex justify-content-center ps-2 align-items-center bg-white gap-10 br-10 border">
                  <RiSearchLine className="text-primary" size={20} />
                  <input
                    type="text"
                    placeholder={"Search"}
                    value={searchKey}
                    className={` ${screenWidth <= 768 && "w-50"} border-0`}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchKey(value);

                      let url = filterUrl || backendUrl;
                      const searchRegex = /([?&])search=[^&]*/;
                      const pageRegex = /([?&])page=[^&]*/;

                      if (searchRegex.test(url)) {
                        url = url.replace(searchRegex, `$1search=${encodeURIComponent(value)}`);
                      } else {
                        if (url.includes("?")) {
                          url = url.endsWith("&") ? url : `${url}&`;
                        } else {
                          url = `${url}?`;
                        }
                        url += `search=${encodeURIComponent(value)}`;
                      }

                      if (pageRegex.test(url)) {
                        url = url.replace(pageRegex, "$1page=1");
                      } else {
                        if (url.includes("?")) {
                          url = url.endsWith("&") ? url : `${url}&`;
                        } else {
                          url = `${url}?`;
                        }
                        url += "page=1";
                      }

                      setFilterUrl(url);
                      setPage(1);

                    }}
                  />
                  <Button
                    className="m-0"
                    onClick={() => fetchRecords(filterUrl)}
                  >
                    Search
                  </Button>
                </div>

                <Button
                  className="ms-1 bg-light text-primary"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </>
            )}
            {showSearchReset && (
              <>
                <Button
                  className="ms-1"
                  onClick={() => fetchRecords(filterUrl)}
                >
                  Search
                </Button>

                <Button
                  className="ms-1 bg-light text-primary"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </>
            )}
            {showExport && (
              <Button
                className="ms-1 bg-light text-primary "
                onClick={() => handleExport()}
                disabled={exporting}
                style={{ maxWidth: "110px", width: "100%" }}
              >
                Export
                {exporting && <Spinner animation="border" size="sm" className="ms-2" />}
              </Button>
            )}
          </div>
        </div>
        <div
          className={`w-100 br-10 bg-white scrollbar-none ${title === "Payout" ? "" : "my-3 mb-4"
            } `}
          style={{ overflowX: "scroll" }}
        >
          <div
            ref={containerRef}
            className={`w-100 fs-15 d-flex align-items-center py-3 px-4`}
          >
            {rowHeadings?.map((item, index) => (
              <div
                key={index}
                className={
                  rowHeadings?.length < 4
                    ? "col-4"
                    : rowHeadings?.length === 4
                      ? "col-6 col-md-3"
                      : item?.title === "Name/Email"
                        ? "col-8 col-md-3"
                        : screenWidth < 768 && item?.key === "project_start_date"
                          ? ` ${screenWidth < 768 ? "col-8 " : ""} `
                          : (item?.key === "invoice_number" ||
                            item?.key === "invoice_details.invoice_number") &&
                            screenWidth < 900
                            ? "col-8"
                            : `${screenWidth < 900 ? "col-6" : "w-100"
                            } justify-content-between mx-2`
                }
              >
                {item?.title}
              </div>
            ))}
          </div>
          <div className="d-flex">
            <div
              style={{
                borderBottom: "1px solid #CECECE",
                minWidth: screenWidth >= 768 ? "100%" : containerWidth,
              }}
            />
          </div>
          <div className="py-2 scrollbar-none">
            {(rowData.length === 0 || loading) && (
              <NoData label={title} loading={loading} height="20vh" />
            )}
            {!loading &&
              rowData?.map((item, rowIndex) => (
                <div
                  key={rowIndex}
                  className="d-flex fs-14 align-items-center py-3 px-4"
                >
                  {rowHeadings?.map((heading, colIndex) => (
                    <div
                      key={colIndex}
                      className={
                        rowHeadings?.length < 4
                          ? "col-4"
                          : rowHeadings.length === 4
                            ? "col-6 col-md-3"
                            : heading?.title === "Name/Email"
                              ? "col-8 col-md-3"
                              : screenWidth < 768 &&
                                heading.key === "project_start_date"
                                ? ` ${screenWidth < 768 ? "col-8 " : ""} `
                                : (heading?.key === "invoice_number" ||
                                  heading?.key ===
                                  "invoice_details.invoice_number") &&
                                  screenWidth < 900
                                  ? "col-8"
                                  : ` ${screenWidth < 900 ? "col-6" : "w-100"
                                  } justify-content-between mx-2`
                      }
                    >
                      {heading.key === "status" ? (
                        <span
                          className="p-2 br-5  c-p "
                          onClick={(e) =>
                            handleStatusChange(e, item?.id, item?.status)
                          }
                          style={{
                            backgroundColor:
                              item?.status === "ACTIVE" ||
                                item?.status === "COMPLETED"
                                ? "#E6F7EB"
                                : "#F2E6E6",
                            color:
                              item?.status === "ACTIVE" ||
                                item?.status === "COMPLETED"
                                ? "#06A82A"
                                : "#FF4C00",
                          }}
                        >
                          {item?.status?.split("_").join(" ")}
                        </span>
                      ) : heading.title === "Action" ? (
                        <div
                          className="text-primary d-flex"
                          style={{ zIndex: "999" }}
                        >
                          {rowActions?.map((action, index) =>
                            action === "edit" ? (
                              <div
                                key={index}
                                onClick={() => {
                                  setItemId(item?.id);
                                  if (createUrl === "modal") {
                                    setShowAddModal(true);
                                  } else if (createUrl === "invoice") {
                                    navigate(`/invoices/add/${item?.id}`);
                                  } else if (title === "Invoice Payment") {
                                    setShowPayments(false);
                                    setShowRegister(true);
                                  } else {
                                    setShowAdd(true);
                                  }
                                }}
                                className="bg-light p-1 m-1 d-flex align-items-center justify-content-center br-8  c-p "
                              >
                                <img src={edit} alt="Edit" />
                              </div>
                            ) : action === "delete" ? (
                              <React.Fragment key={index}>
                                {((title === "Timesheets" &&
                                  (user?.is_admin ||
                                    item?.employee_email === user?.username)) ||
                                  title !== "Timesheets") && (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        setDeleteId(item?.id);
                                        setShowDelete(true);
                                      }}
                                      className="bg-light p-1 m-1 d-flex align-items-center justify-content-center br-8  c-p "
                                    >
                                      <img src={trash} alt="Delete" size={20} />
                                    </div>
                                  )}
                              </React.Fragment>
                            ) : action === "view" ? (
                              <div
                                key={index}
                                onClick={() => {
                                  if (viewType === "new_page") {
                                    window.open(
                                      `${viewUrl}${item?.id}`,
                                      "_blank"
                                    );
                                  } else {
                                    navigate(`${viewUrl}${item?.id}`);
                                  }
                                }}
                                className="bg-light p-1 m-1 d-flex align-items-center justify-content-center br-8  c-p "
                              >
                                <FiEye size={20} />
                              </div>
                            ) : action === "details" ? (
                              <div
                                key={index}
                                onClick={() => {
                                  navigate(`/bookings/${item.id}`);
                                }}
                                className="bg-light p-1 px-2 text-primary br-8  c-p "
                              >
                                <div>Details</div>
                              </div>
                            ) : action === "download_file" ? (
                              <div
                                key={index}
                                onClick={() => {
                                  handleFileDownload(item);
                                }}
                                className={
                                  item?.file
                                    ? "bg-light p-1 m-1 d-flex align-items-center justify-content-center br-8 c-p"
                                    : "d-none"
                                }
                              >
                                <IoCloudDownloadOutline
                                  size={20}
                                  className="text-primary"
                                />
                              </div>
                            ) : action === "approve_reject" ? (
                              <div key={index} className="d-flex gap-1">
                                <LeaveActions
                                  item={rowData?.find((i) => i.id === item?.id)}
                                  setItemId={setItemId}
                                  fetchData={fetchRecords}
                                  setShowAdd={setShowAdd}
                                  handleMarkMilestoneComplete={
                                    handleMarkMilestoneComplete
                                  }
                                  setShowDelete={setShowDelete}
                                  setDeleteId={setDeleteId}
                                  handleApproveRejectLeave={
                                    handleApproveRejectLeave
                                  }
                                />
                              </div>
                            ) : action === "send_invoice" ? (
                              <span
                                key={index}
                                onClick={() => {
                                  item?.status === "INVOICE_SENT"
                                    ? handleSendReminder(item?.id)
                                    : handleSendInvoice(item?.id);
                                }}
                                className="d-flex align-items-center justify-content-center w-100 bg-light fs-12 d-flex align-items-center br-5  c-p "
                              >
                                {item?.status === "INVOICE_SENT"
                                  ? "Send Reminder"
                                  : "Send Invoice"}
                              </span>
                            ) : action === "invoice_actions" ? (
                              <div key={index} className="pe-1">
                                <InvoiceActions
                                  setItemId={setItemId}
                                  itemId={item?.id}
                                  item={rowData?.find((i) => i.id === item?.id)}
                                  fetchData={fetchRecords}
                                  setShowRegister={setShowRegister}
                                  showRegister={showRegister}
                                  handleDownloadInvoice={() =>
                                    handleDownloadInvoice(item?.id)
                                  }
                                  downloading={downloading}
                                  handleSendReminder={() =>
                                    handleSendReminder(item?.id)
                                  }
                                  handleSendInvoice={handleSendInvoice}
                                  setShowPayments={setShowPayments}
                                  setShowDelete={setShowDelete}
                                  setDeleteId={setDeleteId}
                                  setShowNonRecoverable={setShowNonRecoverable}
                                  setShowDelayCharges={setShowDelayCharges}
                                />
                              </div>
                            ) : action === "milestone_actions" ? (
                              <div key={index}>
                                <MilestoneActions
                                  itemId={item?.id}
                                  setItemId={setItemId}
                                  item={rowData?.find((i) => i.id === item?.id)}
                                  fetchData={fetchRecords}
                                  setShowAdd={setShowAdd}
                                  handleMarkMilestoneComplete={
                                    handleMarkMilestoneComplete
                                  }
                                  setShowDelete={setShowDelete}
                                  setDeleteId={setDeleteId}
                                />
                              </div>
                            ) : action === "project_actions" ? (
                              <div key={index}>
                                <ProjectActions
                                  itemId={item?.id}
                                  setItemId={setItemId}
                                  item={rowData?.find((i) => i.id === item?.id)}
                                  fetchData={fetchRecords}
                                  setShowAdd={setShowAdd}
                                  handleMarkComplete={handleMarkProjectComplete}
                                  setShowDelete={setShowDelete}
                                  setDeleteId={setDeleteId}
                                />
                              </div>
                            ) : null
                          )}
                        </div>
                      ) : heading.key === "employee_array" ? (
                        <div className="d-flex align-items-center mx-2 w-100">
                          <div className="col-6 d-flex">
                            {item?.employee_array?.length === 0 && (
                              <div>0 Members </div>
                            )}
                            {item?.employee_array
                              ?.slice(0, 5)
                              ?.map((emp, index) => (
                                <React.Fragment key={index}>
                                  {emp?.image ? (
                                    <img
                                      key={index}
                                      src={
                                        emp?.image
                                          ? getMediaUrl(emp?.image)
                                          : applogo
                                      }
                                      alt=""
                                      onClick={() =>
                                        navigate(
                                          `/employeemanagement/${emp?.id}`
                                        )
                                      }
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                      }}
                                      className="br-50  c-p "
                                    />
                                  ) : (
                                    <LuUserCircle2
                                      onClick={() =>
                                        navigate(
                                          `/employeemanagement/${emp?.id}`
                                        )
                                      }
                                      size={32}
                                      className="text-grey  c-p "
                                    />
                                  )}
                                </React.Fragment>
                              ))}
                          </div>
                          {item?.employee_array?.length > 5 && (
                            <span className="col-5 fw-500 ms-2">
                              +{item.employee_array.length - 5} Members
                            </span>
                          )}
                        </div>
                      ) : heading.key === "payment_client" ? (
                        <div className="d-flex gap-1 align-items-center">
                          {item?.invoice_details?.project_array?.client_array
                            ?.company_logo ? (
                            <img
                              src={getMediaUrl(
                                item?.invoice_details?.project_array
                                  ?.client_array?.company_logo
                              )}
                              alt="client image"
                              style={{
                                width: "35px",
                                height: "35px",
                                border: "1px solid #82AEC5",
                              }}
                              className="br-50"
                            />
                          ) : (
                            <>
                              <LuUserCircle2 size={35} className="text-grey" />
                            </>
                          )}
                          <span className="fw-400">
                            {heading?.capitalize ? truncateString(toTitleCase(item?.invoice_details?.project_array?.client_array?.name), 18) : truncateString(
                              item?.invoice_details?.project_array?.client_array
                                ?.name,
                              18
                            )}
                          </span>
                        </div>
                      ) : heading.key === "payment_project" ? (
                        <div >
                          {heading?.capitalize ? truncateString(toTitleCase(item?.invoice_details?.project_array?.title), 18) : truncateString(
                            item?.invoice_details?.project_array?.title,
                            18
                          )}
                        </div>
                      ) : heading.key === "employee_array.date_of_joining" ? (
                        <div>
                          {formatDateToTextDate(
                            item?.employee_array.date_of_joining
                          )}
                        </div>
                      ) : heading.key === "invoice_details.created_on" ? (
                        <div>
                          {formatDateToTextDate(
                            item?.invoice_details?.created_on
                          )}
                        </div>
                      ) : heading.key === "last_invoice_sent_date" ? (
                        <div>
                          {formatDateToTextDate(getValue(heading, item))}
                        </div>
                      ) : heading.key === "next_invoice_sent_date" ? (
                        <div>
                          {formatDateToTextDate(item?.next_invoice_sent_date)}
                        </div>
                      ) : heading.title === "From" &&
                        heading.key == "start_date" ? (
                        <div>{formatDateToTextDate(item?.start_date)}</div>
                      ) : heading.title === "Till" &&
                        heading.key == "end_date" ? (
                        <div>{formatDateToTextDate(item?.end_date)}</div>
                      ) : heading.key === "leave_employee_details" ? (
                        <div
                          className="d-flex c-p"
                          onClick={() =>
                            navigate(
                              `/employeemanagement/${item?.employee_details?.id}`
                            )
                          }
                        >
                          {item?.employee_details?.image ? (
                            <img
                              key={heading.key}
                              src={getMediaUrl(item?.employee_details?.image)}
                              alt=""
                              onClick={() =>
                                navigate(
                                  `/employeemanagement/${item?.employee_details?.id}`
                                )
                              }
                              style={{ height: "50px", width: "50px" }}
                              className="br-50 c-p"
                            />
                          ) : (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              style={{ height: "50px", width: "50px" }}
                            >
                              <LuUserCircle2 size={50} className="text-grey" />
                            </div>
                          )}
                          <div className="d-flex flex-column">
                            <span className={"fw-500"}>
                              {item?.employee_details?.first_name}{" "}
                              {item?.employee_details?.last_name
                                ? item?.employee_details?.last_name
                                : ""}
                            </span>
                            <span>
                              {truncateString(
                                item?.employee_details?.email,
                                15
                              )}
                            </span>
                          </div>
                        </div>
                      ) : heading.key === "payment_status" ? (
                        <div
                          className="fw-600"
                          style={{
                            color:
                              item?.invoice_details?.status === "PAID"
                                ? "#30D8B9"
                                : "rgb(255, 76, 0)",
                          }}
                        >
                          {backendUrl?.includes(`project/milestone`) ? (
                            <>
                              {item?.payment_status
                                ? item.payment_status.replace(/_/g, " ")
                                : "N/A"}
                            </>
                          ) : item?.invoice_details?.status ? (
                            item?.invoice_details?.status?.replace(/_/g, " ")
                          ) : (
                            "--"
                          )}
                        </div>
                      ) : heading.key === "leave_type_details.is_paid" ? (
                        <div>
                          {item?.leave_type_details?.is_paid ? "Yes" : "No"}
                        </div>
                      ) : heading.key === "timesheet_date" ? (
                        <div>{formatTimesheetDateToTextDate(item?.date)}</div>
                      ) : heading.key === "payment_date" ? (
                        <div>{formatDateToTextDate(item?.payment_date)}</div>
                      ) : heading.key === "date_of_joining" ? (
                        <div>{formatDateToTextDate(item?.date_of_joining)}</div>
                      ) : heading.key === "due_date" ? (
                        <div>{formatDateToTextDate(item?.due_date)}</div>
                      ) : heading.key === "bill_date" ? (
                        <div>{formatDateToTextDate(item?.bill_date)}</div>
                      ) : heading.key === "date" && heading.title === "Date" ? (
                        <div>{formatDateToTextDate(item?.date)}</div>
                      ) : heading.key === "payment_date" &&
                        heading.title === "Date" ? (
                        <div>{formatDateToTextDate(item?.payment_date)}</div>
                      ) : heading.key === "amount_paid" ? (
                        <div className="d-flex fw-600">
                          <span>
                            {formatPrice(
                              item?.amount_paid,
                              item?.invoice_details.project_array?.currency
                                ?.code
                            )}
                          </span>
                        </div>
                      ) : heading.key === "daily_charge" ? (
                        <div className="d-flex">
                          <span>
                            {formatPrice(
                              item?.daily_charge,
                              item?.currency_details
                                ?.code
                            )}
                          </span>
                        </div>
                      ) : heading.key === "amount_paid_inr" ? (
                        <div className="d-flex fw-600">
                          <span>
                            {formatPrice(
                              item?.exchange_rate
                                ? item?.amount_paid * item?.exchange_rate
                                : item?.amount_paid
                            )}
                          </span>
                        </div>
                      ) : heading.key === "profitability" ? (
                        <>
                          <div className="d-flex gap-1">
                            <span
                              className="col-5 fw-600"
                              style={{
                                color: "#30D8B9",
                              }}
                            >
                              {item?.profitability_details?.profit_percent}%
                            </span>
                            <span
                              className="col-7 fw-600"
                              style={{
                                color: "#032638",
                              }}
                            >
                              {formatPrice(item?.profitability_details?.profit)}
                            </span>
                          </div>
                        </>
                      ) : heading.key === "expenses" ? (
                        <div className="fw-600">
                          {formatPrice(item?.expenses)}
                        </div>
                      ) : heading.title === "Name/Email" ? (
                        <div className="d-flex gap-10">
                          {subtitle === "Team List" || title === "Leave" ? (
                            <>
                              {item?.employee_array?.image ? (
                                <img
                                  style={{
                                    height: "50px",
                                    objectFit: "cover",
                                    width: "50px",
                                  }}
                                  src={getMediaUrl(item?.employee_array?.image)}
                                  alt=""
                                  className="br-50"
                                />
                              ) : (
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center"
                                  style={{ height: "50px", width: "50px" }}
                                >
                                  <LuUserCircle2
                                    size={50}
                                    className="text-grey"
                                  />
                                </div>
                              )}
                              <div className="d-flex flex-column">
                                <span className="fw-500">
                                  {heading?.capitalize
                                    ? toTitleCase(`${item?.employee_array?.first_name || ""} ${item?.employee_array?.last_name || ""}`.trim())
                                    : `${item?.employee_array?.first_name || ""} ${item?.employee_array?.last_name || ""}`.trim()
                                  }
                                </span>
                                <span>
                                  {truncateString(
                                    item?.employee_array?.email,
                                    30
                                  )}
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              {item?.image ? (
                                <img
                                  style={{
                                    height: "50px",
                                    objectFit: "cover",
                                    width: "50px",
                                  }}
                                  src={item?.image}
                                  alt=""
                                  className="br-50"
                                />
                              ) : (
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center"
                                  style={{ height: "50px", width: "50px" }}
                                >
                                  <LuUserCircle2
                                    size={49}
                                    className="text-grey"
                                  />
                                </div>
                              )}
                              <div className="d-flex flex-column">
                                <span className="fw-500">
                                  {heading?.capitalize
                                    ? toTitleCase(`${item?.first_name || ""} ${item?.last_name || ""}`.trim())
                                    : `${item?.first_name || ""} ${item?.last_name || ""}`.trim()
                                  }
                                </span>
                                <span>
                                  {truncateString(
                                    item?.email,
                                    screenWidth >= 768 ? 30 : 13
                                  )}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <>
                          {heading.key === "created_on" ||
                            heading.key === "created_at" ? (
                            <div>
                              {formatDateTimeString(
                                item[
                                heading.key.split("").join("").toLowerCase()
                                ]
                              )}
                            </div>
                          ) : heading.key === "timestamp" ? (
                            <div>
                              {formatDateTimeTogetherString(
                                item[
                                heading.key.split("").join("").toLowerCase()
                                ]
                              )}
                            </div>
                          ) : heading.key === "project_client" ? (
                            <>
                              <div className="d-flex gap-1 align-items-center">
                                {item?.client_array?.company_logo ? (
                                  <img
                                    src={getMediaUrl(
                                      item?.client_array?.company_logo
                                    )}
                                    alt="client image"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      border: "1px solid #82AEC5",
                                    }}
                                    className="br-50"
                                  />
                                ) : (
                                  <>
                                    <LuUserCircle2
                                      size={35}
                                      className="text-grey"
                                    />
                                  </>
                                )}
                                <span className="fw-400">
                                  {heading.capitalize ? truncateString(toTitleCase(item?.client_array?.name), 18) : truncateString(item?.client_array?.name, 18)}
                                </span>
                              </div>
                            </>
                          ) : heading.key === "client_name" ? (
                            <>
                              <div
                                onClick={() => navigate(`/clients/${item?.id}`)}
                                className="d-flex gap-1 align-items-center c-p"
                              >
                                {item?.company_logo ? (
                                  <img
                                    src={
                                      item?.company_logo
                                        ? getMediaUrl(item?.company_logo)
                                        : ""
                                    }
                                    alt="client image"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      border: "1px solid #82AEC5",
                                    }}
                                    className="br-50"
                                  />
                                ) : (
                                  <>
                                    <LuUserCircle2
                                      size={35}
                                      className="text-grey"
                                    />
                                  </>
                                )}
                                <span className="fw-400">{heading?.capitalize ? toTitleCase(item?.name) : item?.name}</span>
                                {item?.marked_as_red_flag && (
                                  <span
                                    title="Red-flagged client"
                                    style={{ marginLeft: "6px", fontSize: "16px", color: "#ff4d4f" }}
                                  >
                                    🚩
                                  </span>
                                )}
                              </div>
                            </>
                          ) : heading.key === "emp_id" ? (
                            <span
                              onClick={() =>
                                navigate(`/employeemanagement/${item?.id}`)
                              }
                              className="fw-600 c-p"
                            >
                              {item?.emp_id}
                            </span>
                          ) : heading.key === "recurring_period" ? (
                            <span>
                              {recurringTimeOptions?.find(
                                (i) => i.value == item?.recurring_period
                              )?.label || "--"}
                            </span>
                          ) : heading.key === "is_stopped" ? (
                            <span
                              onClick={() =>
                                handleStopResumeInvoice(
                                  item?.id,
                                  item?.is_stopped
                                )
                              }
                              className="p-1 br-5 c-p"
                              style={{
                                backgroundColor: item?.is_stopped
                                  ? "#E6F7EB"
                                  : "#F2E6E6",
                                color: item?.is_stopped ? "#06A82A" : "#FF4C00",
                              }}
                            >
                              {item?.is_stopped ? "RESUME" : "STOP"}
                            </span>
                          ) : heading.key === "invoice_number" ? (
                            <span
                              onClick={() => navigate(`/invoices/${item?.id}`)}
                              className="fw-600 c-p"
                            >
                              {item?.invoice_number}
                            </span>
                          ) : heading.key === "name" && title === "Vendor" ? (
                            <span
                              onClick={() => navigate(`/vendors/${item?.id}`)}
                              className="fw-600 c-p"
                            >
                              {heading.capitalize ? toTitleCase(item?.name) : item?.name}
                            </span>
                          ) : heading.key === "ref_number" ? (
                            <span
                              className="fw-600"
                              style={{ color: "#116C96" }}
                            >
                              {item.ref_number}
                            </span>
                          ) : heading.key === "expense_vendor" ? (
                            <>
                              <div className="d-flex gap-1 align-items-center">
                                {item?.vendor_array?.img ? (
                                  <img
                                    src={item?.vendor_array?.img}
                                    alt="client image"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      border: "1px solid #82AEC5",
                                    }}
                                    className="br-50"
                                  />
                                ) : (
                                  <>
                                    <LuUserCircle2
                                      size={35}
                                      className="text-grey"
                                    />
                                  </>
                                )}
                                <span className="fw-600">
                                  {heading.capitalize ? toTitleCase(item?.vendor_array?.name || "--") : item?.vendor_array?.name || "--"}
                                </span>
                              </div>
                            </>
                          ) : heading.key === "invoice_client" ? (
                            <>
                              <div className="d-flex gap-1 align-items-center">
                                {item?.project_array?.client_array
                                  ?.company_logo ? (
                                  <img
                                    src={getMediaUrl(
                                      item?.project_array?.client_array
                                        ?.company_logo
                                    )}
                                    alt="client image"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      border: "1px solid #82AEC5",
                                    }}
                                    className="br-50"
                                  />
                                ) : (
                                  <>
                                    <LuUserCircle2
                                      size={30}
                                      className="text-grey"
                                    />
                                  </>
                                )}
                                <span className="fw-400">
                                  {heading.capitalize ? truncateString(toTitleCase(item?.project_array?.client_array?.name), 10) : truncateString(
                                    item?.project_array?.client_array?.name,
                                    10
                                  )}
                                </span>
                              </div>
                            </>
                          ) : heading.key === "invoice_project_name" ? (
                            <div className="d-flex flex-column">
                              {truncateString(item?.project_array?.title)}
                            </div>
                          ) : heading.key === "total" ? (
                            <div>
                              {formatPrice(
                                item?.total,
                                item?.currency_details?.code
                              )}
                            </div>
                          ) : heading.key === "remaining_amount" ? (
                            <div>
                              {formatPrice(
                                item?.remaining_amount,
                                item?.currency_details?.code
                              )}
                            </div>
                          ) : heading.key === "amount" || heading.key === "amount_excl_gst" || heading.key === "cgst" || heading.key === "sgst" || heading.key === "igst" ? (
                            <div className="fw-600">
                              {formatPrice(
                                getValue(heading, item),
                                backendUrl === "expense/expense" ||
                                  backendUrl?.includes("expense/expense")
                                  ? "INR"
                                  : item?.project_array?.currency?.code || "INR"
                              )}
                            </div>
                          ) : heading.key === "project_start_date" ? (
                            <div className="d-flex flex-column">
                              <div className="d-flex gap-1 align-items-center">
                                <span className="fw-600">Start: </span>
                                <span>
                                  {item?.start_date
                                    ? formatDateToTextDate(item?.start_date)
                                    : "--"}
                                </span>
                              </div>
                              <div className="d-flex gap-1 align-items-center">
                                <span className="fw-600">End: </span>
                                <span>
                                  {item?.end_date
                                    ? formatDateToTextDate(item?.end_date)
                                    : "--"}
                                </span>
                              </div>
                            </div>
                          ) : heading.key === "project_type" ? (
                            <div>
                              <span
                                className="p-2 br-8"
                                style={{
                                  backgroundColor:
                                    item?.project_type === "FIXED BUDGET"
                                      ? "#E6EBF2"
                                      : item?.project_type === "HOURLY"
                                        ? "#EBF2E6"
                                        : "#F2E6E6",
                                  color:
                                    item?.project_type === "FIXED BUDGET"
                                      ? "#063E72"
                                      : item?.project_type === "HOURLY"
                                        ? "#297206"
                                        : "#D20D00",
                                }}
                              >
                                {item?.project_type}
                              </span>
                            </div>
                          ) : heading.key === "cost" ? (
                            <div className="text-primary fw-600">
                              {!item?.cost && "--"}
                              {item.cost &&
                                formatPrice(item.cost, item?.currency?.code)}
                            </div>
                          ) : heading.key === "website_url" ? (
                            <div
                              onClick={() => {
                                item?.website_url &&
                                  handleUrlClick(item?.website_url);
                              }}
                              className={`text-primary fw-500 ${item?.website_url && " c-p "
                                } `}
                            >
                              {item?.website_url
                                ? truncateString(item?.website_url)
                                : "N/A"}
                            </div>
                          ) : heading.key === "address" ? (
                            item?.address_array && (
                              <div className="d-flex ">
                                {item?.address_array?.address
                                  ? item?.address_array?.address + " ,"
                                  : ""}
                                {item?.address_array?.city
                                  ? item?.address_array?.city + " ,"
                                  : ""}
                                {item?.address_array?.state_name
                                  ? item?.address_array?.state_name + " ,"
                                  : ""}
                                {item?.address_array?.country_name
                                  ? item?.address_array?.country_name + ","
                                  : ""}

                                {item?.address_array?.zipcode
                                  ? item?.address_array?.zipcode
                                  : ""}
                              </div>
                            )
                          ) : heading.key === "title" && title === "Project" ? (
                            <span
                              className="c-p fw-600"
                              onClick={() => navigate(`/projects/${item?.id}`)}
                            >
                              {heading.capitalize ? toTitleCase(item?.title) : item?.title}
                            </span>
                          ) : heading.key === "total_amount_paid" ? (
                            <span className="fw-600">
                              {formatPrice(item?.total_amount_paid)}
                            </span>
                          ) : heading.key === "total_cost" ? (
                            <div>{formatPrice(item?.total_cost)}</div>
                          ) : heading.key === "company_address" ? (
                            item?.company_address ? (
                              <div className="d-flex">
                                {item?.company_address_array?.address
                                  ? item?.company_address_array?.address + " ,"
                                  : ""}
                                {item?.company_address_array?.city
                                  ? item?.company_address_array?.city + " ,"
                                  : ""}
                                {item?.company_address_array?.state_name
                                  ? item?.company_address_array?.state_name +
                                  " ,"
                                  : ""}
                                {item?.company_address_array?.country_name
                                  ? item?.company_address_array?.country_name +
                                  ","
                                  : ""}
                                {item?.company_address_array?.zipcode
                                  ? item?.company_address_array?.zipcode
                                  : ""}
                              </div>
                            ) : (
                              <span>N/A</span>
                            )
                          ) : heading.key === "id" ||
                            heading.key === "name" ||
                            heading.key === "company_name" ||
                            heading.key === "title" ? (
                            <div className="fw-600">
                              {heading.key === "id"
                                ? item.id
                                : heading.key === "phone"
                                  ? item.phone
                                  : heading.key === "email"
                                    ? item.license_number
                                    : heading.key === "company_name"
                                      ? item.company_name
                                      : heading.key === "title"
                                        ? heading.capitalize ? toTitleCase(item?.title) : item?.title
                                        : item.name}
                            </div>
                          ) : (
                            <div className="">
                              <span>
                                {heading?.capitalize
                                  ? toTitleCase(truncateString(getValue(heading, item)))
                                  : truncateString(getValue(heading, item))}
                              </span>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              ))}
          </div>
          <div className="d-flex">
            <div
              style={{
                borderBottom: "1px solid #CECECE",
                minWidth: screenWidth >= 768 ? "100%" : containerWidth,
              }}
            />
          </div>
        </div>

        {rowData?.length > 0 && !loading && (
          <div className="d-flex pb-3">
            <PaginationComponent
              totalItems={totalItems}
              itemsPerPage={10}
              fetchRecords={handlePagination}
              backendUrl={backendUrl}
              page={page}
              setPage={setPage}
              setFilterUrl={setFilterUrl}
            />
          </div>
        )}
      </div>

      {showRegister && (
        <div className="d-flex justify-content-end align-items-end h-100">
          <CustomAddBox
            show={showRegister}
            itemId={itemId}
            item={rowData?.find((i) => i.id === itemId)}
            onHide={() => setShowRegister(false)}
            title={"Register Payment"}
            fetchData={fetchRecords}
            action={title === "Invoice Payment" && "edit"}
          />
        </div>
      )}
      {showPayments && (
        <div className="d-flex justify-content-end align-items-end h-100">
          <CustomAddBox
            show={showPayments}
            itemId={itemId}
            onHide={() => setShowPayments(false)}
            title={"Invoice Payment"}
            fetchData={fetchRecords}
          />
        </div>
      )}
      {showDelayCharges && (
        <div className="d-flex justify-content-end align-items-end h-100">
          <CustomAddBox
            show={showDelayCharges}
            itemId={itemId}
            onHide={() => setShowDelayCharges(false)}
            title={"Delay Charges"}
            fetchData={fetchRecords}
          />
        </div>
      )}
      {showAdd && (
        <div className="d-flex justify-content-end align-items-end w-100">
          <CustomAddModal
            show={showAdd}
            itemId={itemId}
            onHide={() => {
              setShowAdd(false);
              setItemId("");

              if (createLayout === "centered" && window.opener) {
                window.close();
              }
            }}
            title={title}
            layout={createLayout}
            fetchData={fetchRecords}
            clientId={clientId}
            contacts={contacts}
            onCreated={onCreateSuccess}
          />
        </div>
      )}
      {showAddModal && (
        <div className="d-flex justify-content-end align-items-end h-100">
          <CustomAddBox
            show={showAddModal}
            itemId={itemId}
            onHide={() => setShowAddModal(false)}
            title={title}
            fetchData={() => fetchRecords()}
          />
        </div>
      )}
      {showDelete && (
        <DeleteModal
          show={showDelete}
          onHide={() => {
            setShowDelete(false);
            setDeleteId(null);
          }}
          onClick={() => {
            handleDelete(deleteId);
            setShowDelete(false);
            setDeleteId(null);
          }}
        />
      )}
      {showNonRecoverable && (
        <Modal
          className="w-100 d-flex justify-content-center align-items-center"
          show={showNonRecoverable}
          onHide={() => setShowNonRecoverable(false)}
        >
          <div
            className="w-100 d-flex flex-column justify-content-center align-items-center p-5 pt-4 gap-3"
            style={{ minWidth: "500px" }}
          >
            <div className="fs-20 fw-600">Mark Invoice as Non-recoverable</div>
            <div className="w-100">
              <div className="w-100">
                <label className="fw-500">Reason for marking non-recoverable:</label>
                <textarea
                  className="form-control mt-1"
                  rows="3"
                  placeholder="Enter reason..."
                  value={nonRecoverableReason}
                  onChange={(e) => setNonRecoverableReason(e.target.value)}
                />
              </div>

              <label className="d-flex align-items-center mt-2">
                <input
                  type="checkbox"
                  checked={markRedFlag}
                  onChange={() => setMarkRedFlag(!markRedFlag)}
                  style={{ height: "15px", width: "15px" }}
                />
                <span className="ms-2 c-p">Mark this customer as Red-Flag</span>
              </label>

              <div className="d-flex justify-content-center gap-20 mt-3">
                <Button
                  onClick={() => setShowNonRecoverable(false)}
                  className="border-0 px-4"
                  style={{ backgroundColor: "#838383" }}
                >
                  Cancel
                </Button>

                <Button
                  className="px-4"
                  disabled={submitting}
                  onClick={() => {
                    if (!nonRecoverableReason.trim()) {
                      notify("Please enter a reason", "warning");
                      return;
                    }
                    handleMarkNonRecoverable(itemId, nonRecoverableReason, markRedFlag);
                    setShowNonRecoverable(false);
                  }}
                >
                  Confirm
                  {submitting && <Spinner className="ms-2" />}
                </Button>
              </div>
            </div>

          </div>
        </Modal>
      )}

    </div>
  );
};

export default CustomTable;
